'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isThisMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isThisMonth.js
// module id = 318
// module chunks = 0